<script>
// assets/project/src/components/Base/BaseLocationOnlyCityRegion.vue

import axios from "axios";
import SearchAutocompleteCities from "./../Base/SearchAutocompleteCities";
import { useLocationStore } from '@/stores/locationStore'

export default {
	name: "BaseLocation.vue",
	props: {
		city: {},
		region: {},
		labelCity: {},
		labelRegion: {},
		isDataUpdating: {},
		isCityRequired: {},
		isRegionRequired: {}
	},
	data() {
		return {
			country: 'Российская Федерация',
			countryNumber: 'RU',
			//Список городов для отображения
			citiestoinput: '',
			cityField: '',
			regionField: ''
		};
	},
	components: {
		SearchAutocompleteCities
	},
	computed: {},
	async created() {
		this.cityField = this.city;
		this.regionField = this.region;
		await this.loadCities();
	},
	methods: {
		saveData() {},
		async loadCities() {
			const locationStore = useLocationStore()
			try {
				const cities = await locationStore.fetchCities(this.countryNumber)
				this.citiestoinput = cities
			} catch (error) {
				console.log('Ошибка при загрузке городов:', error)
				this.citiestoinput = []
			}
		},
		isFieldRequired() {
			return false;
			//return this.$parent.isFieldRequired(key);
		},
		setRegionNew(city) {
			const findItem = this.citiestoinput.find(el => el.ru_name === city);
			if(findItem) {
				this.$emit('update:region', findItem.region);
				this.$emit('onChange');
			}
		},
		setRegion() {},
		handleRegionClick() {
			if (this.city.length === 0) {
				alert('Выберите город');
				return;
			}
			alert('Это поле заполняется автоматически')
		},
		cityChange() {
			this.$emit('update:city', this.cityField);
			if (this.cityField.length === 0) {
				this.regionField = '';
				this.$emit('update:region', '');
			}
			
			this.setRegionNew(this.cityField)
			this.$emit('onChange');
		},
		handleCityClick() {},
	}
}
</script>

<template>
    <div class="columns city_region_wrapper">
        <div class="column">
            <SearchAutocompleteCities
                    :items="citiestoinput"
                    ref="predpolCityAutocomlete"
                    v-model="cityField"
                    :label="labelCity"
                    :isDataUpdating="isDataUpdating"
                    :is-required="isCityRequired"
                    @onChange="cityChange"
                    @onBlur="cityField = ''"
                    @cityClick="handleCityClick"
            >
            </SearchAutocompleteCities>
        </div>
        <div class="column">
            <div class="field">
                <label :class="isFieldRequired(regionKey) || isRegionRequired ? 'req': ''">{{ labelRegion }}</label>
                <input :disabled="isDataUpdating" readonly @click="handleRegionClick" type="text" :value="region">
            </div>
        </div>
    </div>
</template>
<style scoped>
</style>